import IncomingTripRequestsContainer from './incoming-container';

export default IncomingTripRequestsContainer;
